import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  update: { updating: false, success: false },
  data: [],
  loading: false,
  error: null,
};
const ownerSlice = createSlice({
  name: "ownerdetails",
  initialState,
  reducers: {
    fetchOwnerListRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchOwnerListSuccess(state, action) {
      state.data = action.payload.data;
      state.loading = false;
    },
    fetchOwnerListFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
export const {
  fetchOwnerListRequest,
  fetchOwnerListSuccess,
  fetchOwnerListFailure,
} = ownerSlice.actions;
export default ownerSlice.reducer;
